"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webappBffMethods = void 0;
exports.generateRepositoryMethods = generateRepositoryMethods;
const app_methods_1 = require("./app.methods");
const dashboard_methods_1 = require("./dashboard.methods");
const insurance_methods_1 = require("./insurance.methods");
const medicationPlans_methods_1 = require("./medicationPlans.methods");
const mfa_methods_1 = require("./mfa.methods");
const order_methods_1 = require("./order.methods");
const patient_methods_1 = require("./patient.methods");
const prescription_methods_1 = require("./prescription.methods");
const product_methods_1 = require("./product.methods");
const promotions_methods_1 = require("./promotions.methods");
const user_methods_1 = require("./user.methods");
function generateRepositoryMethods(methodDef) {
    return methodDef;
}
exports.webappBffMethods = generateRepositoryMethods(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mfa_methods_1.mfaRepositoryMethods), app_methods_1.appRepositoryMethods), dashboard_methods_1.dashboardRepositoryMethods), medicationPlans_methods_1.medicationPlansRepositoryMethods), order_methods_1.orderRepositoryMethods), patient_methods_1.patientRepositoryMethods), prescription_methods_1.prescriptionRepositoryMethods), product_methods_1.productRepositoryMethods), user_methods_1.userRepositoryMethods), insurance_methods_1.insuranceRepositoryMethods), promotions_methods_1.promotionsRepositoryMethods));
//# sourceMappingURL=repository.types.js.map